// @spec AUD-STR-001
'use client';

import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { MyActivityTable } from '@/features/audit';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/settings/my-activity')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.myActivity'),
  }),
  component: MyActivityPage,
});

/**
 * My Activity page displaying the current user's activity history.
 *
 * Shows a paginated list of audit events where the user is the actor.
 * Available to all authenticated users regardless of role.
 * Enforces AUD-INV-019: users can only see their own activity.
 */
function MyActivityPage() {
  const { t } = useTranslation('settings');
  return (
    <div className="p-8">
      <div className="mx-auto max-w-6xl space-y-6">
        <header>
          <h1 className="text-3xl font-semibold text-foreground">{t('myActivityPage.title')}</h1>
          <p className="text-muted-foreground mt-1">{t('myActivityPage.description')}</p>
        </header>

        <MyActivityTable pageSize={50} />
      </div>
    </div>
  );
}
